import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "@/views/LoginView.vue";
import CotizacionesView from "@/views/CotizacionesView.vue";
import Ordenes_CompraView from "@/views/Ordenes_CompraView.vue";
import NewCotizacionComp from "@/views/NewCotizacionView.vue";
import ProductsView from "@/views/ProductsView.vue";
import ClientView from "@/views/ClientView.vue";
import ProveedoresView from "@/views/ProviderView.vue";
import UsersView from "@/views/UsersView.vue";
import InformationView from "@/views/InformationView.vue";
import NotesView from "@/views/NotesView.vue";
import Facturas_ProveedorView from "@/views/Facturas_ProveedorView.vue";
import Cotizaciones_DetailsView from "@/views/Cotizaciones_DetailsView.vue";
import EstadisticasView from "@/views/EstadisticasView.vue";
import FamiliasView from "@/views/FamiliasView.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/cotizaciones",
    name: "cotizaciones",
    component: CotizacionesView,
    meta: { requiresAuth: true },
  },
  {
    path: "/ordenes_compra",
    name: "ordenes_compra",
    component: Ordenes_CompraView,
    meta: { requiresAuth: true },
  },
  {
    path: "/new_cotizacion",
    name: "new_cotizacion",
    component: NewCotizacionComp,
    meta: { requiresAuth: true },
  },
  {
    path: "/products",
    name: "products",
    component: ProductsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/client",
    name: "client",
    component: ClientView,
    meta: { requiresAuth: true },
  },
  {
    path: "/provider",
    name: "proveedores",
    component: ProveedoresView,
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "users",
    component: UsersView,
    meta: { requiresAuth: true },
  },
  {
    path: "/information",
    name: "information",
    component: InformationView,
    meta: { requiresAuth: true },
  },
  {
    path: "/notes",
    name: "notes",
    component: NotesView,
    meta: { requiresAuth: true },
  },
  {
    path: "/facturasProveedor",
    name: "facturasProveedor",
    component: Facturas_ProveedorView,
    meta: { requiresAuth: true },
  },
  {
    path: "/orden_compra_cotizaciones/:id",
    name: "orden-compra",
    component: Cotizaciones_DetailsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/estadistica",
    name: "estadistica",
    component: EstadisticasView,
    meta: { requireAuth: true },
  },
  {
    path: "/familias",
    name: "familias",
    component: FamiliasView,
    meta: { requireAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("token") !== null;
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthenticated
  ) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
